module.exports = __webpack_public_path__ + "img/de.b3a26713.svg";